import { useMutation } from "@apollo/client";

import { STAND_COMMENT_CREATE } from "graphql/mutation/stand-gql";
import { successNotification, errorNotification } from "components/request-result";


const useMutationStandCommentCreate = ({
    showSuccessNotification = true,
    showErrorNotification = true,
    onCompleted = () => {},
    onError = () => {},
} = {}) => {
    const [ _setStandCommentCreate, { loading } ] = useMutation(STAND_COMMENT_CREATE, {
        update(cache, { data }) {
            const payload = data?.commentCreate;
            if (showSuccessNotification && payload?.label) {
                successNotification({
                    title: payload.label,
                    description: payload.message,
                });
            }
            onCompleted(payload);
        },
        onError(error) {
            if (showErrorNotification) {
                errorNotification(error);
            }
            onError(error);
        },
    });

    return {
        _setStandCommentCreate,
        loadingMutationStandCommentCreate: loading,
    };
};

export default useMutationStandCommentCreate;
